export default __webpack_public_path__ + "static/media/viber_image_2022-06-03_11-23-30-267.81fe65a9.jpg";